import {ModalService} from '../modal';
import {Injectable} from '@angular/core';

@Injectable()
export class SelectInputService extends ModalService {}
